import { useLandingPage } from 'src/app/pages/search/shared/hooks';
import { SuggestedPetitionsV2 } from 'src/app/shared/components/suggestedPetitionsV2';

export const PromotedPetitions: React.FC = () => {
	const {
		data: { showLandingPage },
	} = useLandingPage();

	if (!showLandingPage) return null;

	return (
		<div className="mt-16">
			<SuggestedPetitionsV2 channel="search_index" sourceLocation="search_footer" />
		</div>
	);
};
